import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const EAHubPage = lazy(() =>
  import('../pages/enterprise-architecture/HubPage').then((m) => ({ default: m.HubPage }))
)
const EACapabilityMapPage = lazy(() =>
  import('../pages/enterprise-architecture/CapabilityMapPage').then((m) => ({ default: m.CapabilityMapPage }))
)
const EATogafAdmPage = lazy(() =>
  import('../pages/enterprise-architecture/TogafAdmPage').then((m) => ({ default: m.TogafAdmPage }))
)
const EACurrentTargetPage = lazy(() =>
  import('../pages/enterprise-architecture/CurrentTargetPage').then((m) => ({ default: m.CurrentTargetPage }))
)
const EADecisionsPage = lazy(() =>
  import('../pages/enterprise-architecture/DecisionsPage').then((m) => ({ default: m.DecisionsPage }))
)

export const enterpriseArchitectureRoutes: RouteObject[] = [
  {
    path: 'enterprise-architecture',
    children: [
      { index: true, element: <EAHubPage /> },
      { path: 'hub', element: <EAHubPage /> },
      { path: 'capability-map', element: <EACapabilityMapPage /> },
      { path: 'togaf-adm', element: <EATogafAdmPage /> },
      { path: 'current-target', element: <EACurrentTargetPage /> },
      { path: 'decisions', element: <EADecisionsPage /> },
    ],
  },
]
